import { Injectable } from '@angular/core';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { LanguageEnum } from '../api/models';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  public language: LanguageEnum = LanguageEnum.English;

  public languageChanged$ = new BehaviorSubject<LanguageEnum | null>(null);

  changeLanguage(language: LanguageEnum) {
    this.language = language;
    this.languageChanged$.next(language);
  }

  getLanguageEnum(languageCode: string): LanguageEnum | null {
    switch (languageCode) {
      case 'en':
        return LanguageEnum.English;
      case 'de':
        return LanguageEnum.German;
      default:
        return null;
    }
  }
}
